import { useState } from 'react';
import { Tooltip as MuiTooltip, tooltipClasses } from '@mui/material';
import { colorSet } from '@theme';
import { info_circle_gray400, info_circle_gray600 } from '@assets/icons';

export const Tooltip: React.FC<{ text: string }> = ({ text }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <MuiTooltip
      placement="top-start"
      title={text}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
              marginBottom: '6px'
            }
          }
        },
        tooltip: {
          sx: {
            maxWidth: '200px',
            backgroundColor: colorSet.gray600,
            color: colorSet.white,
            padding: '6px 12px',
            fontSize: '12px',
            fontWeight: '400',
            margin: '0px',
            whiteSpace: 'pre-line'
          }
        }
      }}
    >
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: 16,
          height: 16,
          marginRight: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        {isHovered ? (
          <img src={info_circle_gray600} style={{ width: 16, height: 16 }} />
        ) : (
          <img src={info_circle_gray400} style={{ width: 16, height: 16 }} />
        )}
      </div>
    </MuiTooltip>
  );
};
